import { render, staticRenderFns } from "./iconSvg.vue?vue&type=template&id=65f8a645"
import script from "./iconSvg.vue?vue&type=script&lang=js"
export * from "./iconSvg.vue?vue&type=script&lang=js"
import style0 from "./iconSvg.vue?vue&type=style&index=0&id=65f8a645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports